import { render, staticRenderFns } from "./openAI.vue?vue&type=template&id=7d94d538&scoped=true&"
import script from "./openAI.vue?vue&type=script&lang=js&"
export * from "./openAI.vue?vue&type=script&lang=js&"
import style0 from "./openAI.vue?vue&type=style&index=0&id=7d94d538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d94d538",
  null
  
)

export default component.exports